import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-57db8af3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course-content-warpper"
};
const _hoisted_3 = {
  class: "course-data"
};
const _hoisted_4 = {
  class: "link-list"
};
const _hoisted_5 = {
  class: "text"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_8 = {
  class: "course-list"
};
const _hoisted_9 = {
  key: 0,
  class: "classify-box"
};
const _hoisted_10 = ["onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_12 = {
  class: "course-card-list"
};
const _hoisted_13 = {
  key: 1,
  class: "no-data"
};
const _hoisted_14 = {
  class: "user-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_SpocCourseCard = _resolveComponent("SpocCourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_UserCard = _resolveComponent("UserCard");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "course-content",
    style: _normalizeStyle({
      marginTop: $props.isTop && $options.$schoolId != 203 ? '-95px' : '0px'
    })
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_CardHeader, {
    class: "course-header",
    link: `/courseList.html?type=${this.courseType}&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_6, _hoisted_7]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_8, [$data.typeList && $data.typeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.typeId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_10);
  }), 128))], 2), $data.typeList.length > 4 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = $event => $data.hiddenMoreClass = !$data.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? '展开' : '收起') + " ", 1), _hoisted_11], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [$data.homeCourseList.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.courseType == 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList.slice(0, 3), course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      "course-data": course,
      key: course.id,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["course-data", "userInfo", "authType"]);
  }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.homeCourseList.slice(0, 3), course => {
    return _openBlock(), _createBlock(_component_SpocCourseCard, {
      info: course,
      key: course.courseId,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["info", "userInfo", "authType"]);
  }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Empty)]))])])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_UserCard, {
    userInfo: $props.userInfo,
    zhsRole: $props.zhsRole
  }, null, 8, ["userInfo", "zhsRole"])])])], 4)]);
}